define('home/utils/datetimeUtils',[
    'moment',
], function (
    moment
) {
    'use strict';

    var ISO_8601 = 'YYYY-MM-DDTHH:mm:ssZ';

    var assureTzOffset = function (createdAt) {
        return createdAt.indexOf('+') >= 0 ? createdAt : createdAt + '+00:00';
    };

    var getRelativeDatetime = function (datetime) {
        if (!datetime || datetime === Infinity)
            return null;

        datetime = assureTzOffset(datetime);
        return moment
            .utc(datetime, ISO_8601) // Input time as UTC
            .local()                 // Convert to local
            .fromNow();
    };

    return {
        getRelativeDatetime: getRelativeDatetime,
    };
});

